import { createAction, props } from '@ngrx/store';
import { User } from '../models/user.model';

export const fetchUsersRequest = createAction(
  "[Users] Fetch Users Request",
);

export const fetchUsersSuccess = createAction(
  "[Users] Fetch Users Success",
  props<{ users: { count: number, data: User[] } }>(),
);

export const fetchUsersFailure = createAction(
  "[Users] Fetch Users Failure",
);

export const createUsersRequest = createAction(
  "[Users] Create Users Request",
  props<{ payload: User }>(),
);

export const createUsersSuccess = createAction(
  "[Users] Create Users Success",
  props<{ user: User }>(),
);

export const createUsersFailure = createAction(
  "[Users] Create Users Failure",
);

export const deleteUsersRequest = createAction(
  "[Users] Delete Users Request",
  props<{ payload: { ids: number[]} }>(),
);

export const deleteUsersSuccess = createAction(
  "[Users] Delete Users Success",
  props<{ ids: number[] }>(),
);

export const deleteUsersFailure = createAction(
  "[Users] Delete Users Failure",
);

export const userActionTypes = {
  fetchUsersRequest,
  fetchUsersSuccess,
  fetchUsersFailure,
  createUsersRequest,
  createUsersSuccess,
  createUsersFailure,
  deleteUsersRequest,
  deleteUsersSuccess,
  deleteUsersFailure
};
